const templateTokens = [
  { name: "Customer name", value: "{customer_name}" },
  { name: "Amount requested", value: "{amount_requested}" },
  { name: "Current month", value: "{current_month}" },
  { name: "Previous month", value: "{previous_month}" },
  { name: "Two months ago", value: "{two_months_ago}" },
  { name: "Account balance", value: "{account_balance}" },
  { name: "Overdue", value: "{overdue}" },
  { name: "Overdue + due", value: "{overdue_and_due_this_month}" },
  { name: "Credit limit", value: "{credit_limit}" },
  { name: "Invoices requested", value: "{invoices_requested}" },
  { name: "Account code", value: "{account_code}" },
];

const getCustomerPreviewValues = () => {
  const now = new Date();
  return [
    { token: "customer_name", value: "John Doe" },
    {
      token: "current_month",
      value: now.toLocaleString("en-GB", { month: "long" }),
    },
    {
      token: "previous_month",
      value: new Date(now.getFullYear(), now.getMonth() - 1).toLocaleString("en-GB", { month: "long" }),
    },
    {
      token: "two_months_ago",
      value: new Date(now.getFullYear(), now.getMonth() - 2).toLocaleString("en-GB", { month: "long" }),
    },
    { token: "account_balance", value: "£1,931.98" },
    { token: "overdue", value: "£1,240.32" },
    { token: "overdue_and_due_this_month", value: "£1,431.98" },
    { token: "amount_requested", value: "£1,240.32" },
    { token: "credit_limit", value: "£1,000.00" },
    { token: "invoices_requested", value: "all overdue invoices" },
    { token: "account_code", value: "ACC-CODE" },
  ];
};

const emailTypeOptions = [
  {
    name: "Branded email",
    value: "html",
  },
  {
    name: "Plain text",
    value: "plain",
  },
];

const paymentRequestLevelOptions = [
  {
    name: "User",
    value: "user",
    tip: "This user can only access payment requests sent by them",
  },
  {
    name: "Branch",
    tip: "This user can access payment requests sent by users in the same branch",
    value: "branch",
  },
  {
    name: "All",
    tip: "This user can access all payment requests ",
    value: "merchant",
  },
];

const customerLevelOptions = [
  {
    name: "No access",
    value: "none",
  },
  {
    name: "View only",
    value: "view",
  },
  {
    name: "Request payment",
    value: "requestfrom",
  },
];

const paymentLevelOptions = [
  {
    name: "No access",
    value: "none",
  },
  {
    name: "View only",
    value: "view",
  },
  {
    name: "Issue refunds",
    value: "refund",
  },
];

const payoutLevelOptions = [
  {
    name: "No access",
    value: "none",
  },
  {
    name: "View payouts",
    value: "view",
  },
];

const reconciliationLevelOptions = [
  {
    name: "No access",
    value: "none",
  },
  {
    name: "View only",
    value: "view",
  },
  {
    name: "Perform actions",
    value: "action",
  },
];

const yesNoOptions = [
  {
    name: "No",
    value: "no",
  },
  {
    name: "Yes",
    value: "yes",
  },
];

const invoicesRequestedTokenMap = {
  None: "Total balance",
  Overdue: "Overdue invoices",
  OverdueAndDueThisMonth: "Invoices overdue & due this month",
  All: "All invoices",
};

export {
  templateTokens,
  emailTypeOptions,
  getCustomerPreviewValues,
  invoicesRequestedTokenMap,
  reconciliationLevelOptions,
  payoutLevelOptions,
  paymentRequestLevelOptions,
  customerLevelOptions,
  paymentLevelOptions,
  yesNoOptions,
};
